import { get as _get } from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import isBrowser from 'utils/isBrowser'
import * as classifiedActions from 'reduxBits/classified/actions'
import { selectors as trackingSelectors } from 'reduxBits/tracking'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { searchParameters, globalData } from 'tracking/dataCollectors'

const predictiveSearch = (state) => {
  const input = trackingSelectors.predictiveSearchInput(state)
  const suggestionObjects = trackingSelectors.predictiveSearchSuggestions(state)
  const suggestions = suggestionObjects ? suggestionObjects.map(({ q }) => q) : undefined
  const suggestionsCount = suggestions ? suggestions.length : undefined
  const chosenSuggestion = trackingSelectors.predictiveSearchQ(state)
  const suggestedCategory = {
    label: _get(trackingSelectors.predictiveSearchChosenSuggestion(state), 'cgLabel', null),
  }

  let chosenIndex = -1
  if (suggestions && input) {
    chosenIndex = suggestions.findIndex((suggestion) => suggestion === chosenSuggestion)
  }

  return {
    predictiveSearch: {
      suggestionsCount,
      suggestions,
      chosenIndex,
      suggestedCategory,
      input,
    },
  }
}

const searchHistory = (state) => {
  const chosenHistory = _get(state, ['tracking', 'predictiveSearch', 'chosenHistory'], {})
  const isUsed = _get(chosenHistory, 'history', false)
  return {
    searchHistory: {
      isUsed,
    },
  }
}

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view',
      eventType: 'View',
      objectType: 'Listing',
      domain: 'adout',
      subDomain: 'list',
      origin: {
        id: `${_get(state, 'router.location.pathname')}${_get(state, 'router.location.search')}`,
        type: 'Listing',
        url: encodeURI(window.location.href),
      },
      objectId: `${_get(state, 'router.location.pathname')}${_get(
        state,
        'router.location.search',
      )}`,
      objectFilterSearchNumResult: _get(
        state,
        'classified.searchResults.searchTotal',
        0,
      ).toString(),
    },
    ...predictiveSearch(state),
    ...searchHistory(state),
    ...searchParameters(_get(state, 'searchParams'), _get(state, 'classified.searchResults.query')),
    ...localData,
  })

export const noUpdatedAds = {
  validators: [
    validators.redux(
      '@@router/LOCATION_CHANGE',
      (action) =>
        _get(action, 'payload.location.pathname', '').startsWith('/annonser') && isBrowser(),
    ),
    validators.redux(classifiedActions.NO_UPDATE, (action) => action.payload === 'fetchAds'),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}

export const receiveNewAds = {
  validators: [
    validators.redux(
      '@@router/LOCATION_CHANGE',
      (action) =>
        _get(action, 'payload.location.pathname', '').startsWith('/annonser') && isBrowser(),
    ),
    validators.redux(classifiedActions.RECEIVE_ADS),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}
